"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      position: 'relative',
      margin: '32px 0px',
      height: '1px'
    },
    divider: function divider(props) {
      return {
        position: props.width === 'containerWidth' ? 'relative' : 'absolute',
        margin: 0,
        border: '1px solid lightgray',
        borderWidth: '1px 0 0',
        width: props.width === 'containerWidth' ? '100%' : '100vw',
        transform: props.width === 'containerWidth' ? 'none' : 'translate(-50vw, 0)',
        left: props.width === 'containerWidth' ? 'auto' : '49.2%'
      };
    }
  };
});
var SectionDividerEditConfig = {
  emptyLabel: 'Section Divider',
  isEmpty: function isEmpty() {
    return false;
  }
};
var SectionDivider = function SectionDivider(_ref) {
  var width = _ref.width;
  var classes = useStyles({
    width: width
  });
  return __jsx("div", {
    className: "".concat(classes.wrapper, " right-rail--divider_space")
  }, __jsx("hr", {
    className: classes.divider
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/sectiondivider')(SectionDivider, SectionDividerEditConfig);
exports.default = _default;